import { render, staticRenderFns } from "./ifc-xkt-viewer.vue?vue&type=template&id=79707623"
import script from "./ifc-xkt-viewer.vue?vue&type=script&lang=js"
export * from "./ifc-xkt-viewer.vue?vue&type=script&lang=js"
import style0 from "./ifc-xkt-viewer.vue?vue&type=style&index=0&id=79707623&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports